import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getProductStruct, setData } from './ProductStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue, formFieldToReqJSON } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './ProductAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import {
    updateProductObj, addProductObj, setShowEditForProduct, updatePharmaorderObj, setPhpackagingmaterialDashboardPhpackagingmaterialList,
    setPackagingsizeDashboardPackagingsizeList, setPharmasetDashboardPharmasetList, setPhproductshapeDashboardPhproductshapeList,
    setSelectedCompositiontemplateId, setCompositiontemplateList
} from 'store/slice/PharmaSlice';
import { addProductAPI, updateProductAPI } from 'api/OmsOrdermgmtWebServices';
import EditproductActionModal from './action/editproduct/EditproductActionModal';
import { setProductEditproductModal } from 'store/slice/PharmaSlice';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { setInfoMsg, setCompType } from 'store/slice/AppSlice';
import { getAPI as getCompositionTemplateObj } from "components/compositiontemplate/CompositiontemplateAPI";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import NonTabletPriceCalculation from './components/price-calculation/NonTabletPriceCalculation';

export default function ProductEditFormImpl() {
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getProductStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { compositiontemplateObj } = useSelector((state) => state.pharmaslice.compositiontemplateDashboard)
    const { editproductModalOpen } = useSelector((state) => state.pharmaslice.productDashboard);
    const {myBusinessUserList} = useSelector((state) => state.headerslice);
    const {foodcompositionObj} = useSelector((state) => state.pharmaslice.foodcompositionDashboard);

    const [pmList, setPMList] = useState([]);

    const [apiInProgress, setApiInProgress] = useState(true);

    const { productDashboard, packagingsizeDashboard, pharmasetDashboard, phproductshapeDashboard } = useSelector((state) => state.pharmaslice);
    const [productId, setProductId] = useState(productDashboard.selectedId);
    const { businessid, username,userid } = useSelector((state) => state.headerslice.userprofileInfo)
    const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard)
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard)
    const { selectedCTid, orderType, compType } = useSelector((state) => state.appslice);

    const { gstList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForgstid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'gstname', e.target.value == 0 ? 'Select Item' : gstList.find(obj => obj.id === e.target.value).title);
    }

    const { phproductstatusList } = useSelector((state) => state.pharmaslice);

    const handleDynamicSelectedValueForstatusid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'statusname', e.target.value == 0 ? 'Select Item' : phproductstatusList.find(obj => obj.id === e.target.value).title);
    }
    const { phproductformList } = useSelector((state) => state.pharmaslice);

    const handleDynamicSelectedValueForformid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'formname', e.target.value == 0 ? 'Select Item' : phproductformList.find(obj => obj.id === e.target.value).title);

        updatePMlist(phproductformList.find(obj => obj.id === e.target.value).id)
    }

    const { phpackagingmaterialList } = useSelector((state) => state.pharmaslice);
    const updatePMlist = (selectedFormId) => {
        
        dispatch(setPhpackagingmaterialDashboardPhpackagingmaterialList(
            phpackagingmaterialList.filter(pmObj => pmObj.formid === selectedFormId)
        ))
        dispatch(setPackagingsizeDashboardPackagingsizeList(
            packagingsizeList.filter(psObj => psObj.formid === selectedFormId)
        ))
        dispatch(setPharmasetDashboardPharmasetList(
            pharmasetList.filter(psObj => psObj.formid === selectedFormId)
        ))
        dispatch(setPhproductshapeDashboardPhproductshapeList(
            phproductshapeList.filter(psObj => psObj.formid === selectedFormId)
        ))
    }
    const { phpackagingmaterialDashboard } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForpackagingtypeid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'packagingtypename', e.target.value == 0 ? 'Select Item' : phpackagingmaterialDashboard.phpackagingmaterialList.find(obj => obj.id === e.target.value).title);
    }
    const { phproductshapeList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForshapeid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'shapename', e.target.value == 0 ? 'Select Item' : phproductshapeList.find(obj => obj.id === e.target.value).title);
    }
    const { packagingsizeList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForpackagingsize1id = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'packagingsize1name', e.target.value == 0 ? 'Select Item' : packagingsizeList.find(obj => obj.id === e.target.value).title);
    }
    const handleDynamicSelectedValueForpackagingsize2id = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'packagingsize2name', e.target.value == 0 ? 'Select Item' : packagingsizeList.find(obj => obj.id === e.target.value).title);
    }
    const { pharmasetList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForsetid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'setname', e.target.value == 0 ? 'Select Item' : pharmasetList.find(obj => obj.id === e.target.value).title);
    }
    useEffect(() => {
        console.log("compositiontemplateObj=>" + JSON.stringify(compositiontemplateObj));
        if (compType==0 && compositiontemplateObj) {
            // Update formValues with the composition template data
            setFormValues({
                ...formValues,
                ['title']: {
                    ...formValues['title'],
                    value: compositiontemplateObj.title
                },
                ['ctid']: {
                    ...formValues['ctid'],
                    value: compositiontemplateObj.id
                },['comptype']: {
                    ...formValues['comptype'],
                    value: 0
                }
            })
        }
    }, [compositiontemplateObj]);

    useEffect(() => {

    }, [apiInProgress])

    useEffect(() => {     
        setFormValues({
                ...formValues,
                ['repeatproduct']: {
                    ...formValues['repeatproduct'],
                    value: orderType==="REPEAT"?"yes": "no"
                },
            })
    },[orderType]);

    useEffect(()=>{
        if (foodcompositionObj) {
            setFormValues({
                ...formValues,
                ['title']: {
                    ...formValues['title'],
                    value: foodcompositionObj.title
                },
                ['ctid']: {
                    ...formValues['ctid'],
                    value: foodcompositionObj.id
                },
                ['comptype']: {
                    ...formValues['comptype'],
                    value: 1
                }
            })
        }
    },[foodcompositionObj])

    useEffect(() => {
        //alert("productObj.repeatproduct=>"+productObj.repeatproduct)
        // Load the form if Product Order Obj is already set
        // otherwise load the composition template object from selected CT ID
        if ( productObj.id !== undefined && productObj.id !== null && productObj.id !== '' && productObj.id !== -1) {

            dispatch(setCompType(productObj.comptype))
            // Need to load Composition Template Obj if selected product already have the CT ID
            if (productObj.comptype==0) {
                console.log("compType: ", productObj.comptype);
        
                console.log("Loading Composition Template for Drug");
                getCompositionTemplateObj(productObj.ctid, (data) => {
                    const arr = Array.isArray(data) ? data : [data]; // Ensure data is an array as it will be set as Array
                    dispatch(setSelectedCompositiontemplateId(arr[0].id));
                    dispatch(setCompositiontemplateList(arr));
                });
            }

            // Load the form with productObj
            setFormValues({
                ...formValues,
                ['id']: {
                    ...formValues['id'],
                    value: productObj.id
                },
                ['businessid']: {
                    ...formValues['businessid'],
                    value: businessid
                },
                ['partyid']: {
                    ...formValues['partyid'],
                    value: pharmaorderObj.partyid
                },
                ['partyname']: {
                    ...formValues['partyname'],
                    value: pharmaorderObj.partyname
                },
                ['orderid']: {
                    ...formValues['orderid'],
                    value: pharmaorderObj.orderid
                },
                ['title']: {
                    ...formValues['title'],
                    value: productObj.title
                },
                ['ctid']: {
                    ...formValues['ctid'],
                    value: productObj.ctid
                },
                ['brandname']: {
                    ...formValues['brandname'],
                    value: productObj.brandname
                },
                ['rate']: {
                    ...formValues['rate'],
                    value: productObj.rate
                },
                ['mrp']: {
                    ...formValues['mrp'],
                    value: productObj.mrp
                },['mrptext']: {
                    ...formValues['mrptext'],
                    value: productObj.mrptext
                }
                , ['formid']: {
                    ...formValues['formid'],
                    value: productObj.formid
                }, ['batchsize']: {
                    ...formValues['batchsize'],
                    value: productObj.batchsize
                }, ['cr_cash']: {
                    ...formValues['cr_cash'],
                    value: productObj.cr_cash
                }, ['formname']: {
                    ...formValues['formname'],
                    value: productObj.formname
                },
                ['packagingsize1id']: {
                    ...formValues['packagingsize1id'],
                    value: productObj.packagingsize1id
                }, ['packagingsize1name']: {
                    ...formValues['packagingsize1name'],
                    value: productObj.packagingsize1name
                }, ['packagingtypeid']: {
                    ...formValues['packagingtypeid'],
                    value: productObj.packagingtypeid
                }, ['packagingtypename']: {
                    ...formValues['packagingtypename'],
                    value: productObj.packagingtypename
                }
                , ['packagingsize2id']: {
                    ...formValues['packagingsize2id'],
                    value: productObj.packagingsize2id
                }, ['packagingsize2name']: {
                    ...formValues['packagingsize2name'],
                    value: productObj.packagingsize2name
                }, ['gstid']: {
                    ...formValues['gstid'],
                    value: productObj.gstid
                }, ['gstname']: {
                    ...formValues['gstname'],
                    value: productObj.gstname
                },
                ['inventorycharges']: {
                    ...formValues['inventorycharges'],
                    value: productObj.inventorycharges
                },
                ['cylindercharges']: {
                    ...formValues['cylindercharges'],
                    value: productObj.cylindercharges
                },
                ['repeatproduct']: {
                    ...formValues['repeatproduct'],
                    value: productObj.repeatproduct
                },
                ['remarks']: {
                    ...formValues['remarks'],
                    value: productObj.remarks
                },
                ['executivename']: {
                    ...formValues['executivename'],
                    value: productObj.executivename
                },
                ['executiveid']: {
                    ...formValues['executiveid'],
                    value: productObj.executiveid
                },
                ['statusname']: {
                    ...formValues['statusname'],
                    value: productObj.statusname
                },['statusid']: {
                    ...formValues['statusid'],
                    value: productObj.statusid
                },
                ['comptype']: {
                    ...formValues['comptype'],
                    value: productObj.comptype
                },['packagingtext']: {
                    ...formValues['packagingtext'],
                    value: productObj.packagingtext
                },
                ['overallstatusid']: {
                    ...formValues['overallstatusid'],
                    value: productObj.overallstatusid
                },
                ['monthtagid']: {
                    ...formValues['monthtagid'],
                    value: productObj.overallstatusid===0?0:productObj.monthtagid
                },
            })
        } else {
            setFormValues({
                ...formValues,
                ['businessid']: {
                    ...formValues['businessid'],
                    value: businessid
                },
                ['partyid']: {
                    ...formValues['partyid'],
                    value: pharmaorderObj.partyid
                },
                ['partyname']: {
                    ...formValues['partyname'],
                    value: pharmaorderObj.partyname
                },
                ['orderid']: {
                    ...formValues['orderid'],
                    value: pharmaorderObj.orderid
                },
                ['executivename']: {
                    ...formValues['executivename'],
                    value: username
                },
                ['executiveid']: {
                    ...formValues['executiveid'],
                    value: userid
                },
                ['overallstatusid']: {
                    ...formValues['overallstatusid'],
                    value: 0
                },
                ['monthtagid']: {
                    ...formValues['monthtagid'],
                    value: 0
                }
                // ['repeatproduct']: {
                //     ...formValues['repeatproduct'],
                //     value: orderType==="REPEAT"?"yes": "no"
                // },
            });
            if (selectedCTid !== null && selectedCTid !== undefined && selectedCTid !== '' && selectedCTid !== -1) {
                // Need to load Composition Template Obj if selected product already have the CT ID
                getCompositionTemplateObj(selectedCTid, (data) => {
                    const arr = Array.isArray(data) ? data : [data]; // Ensure data is an array as it will be set as Array
                    dispatch(setCompositiontemplateList(arr));
                    dispatch(setSelectedCompositiontemplateId(arr[0].id));
                });
            }
        }
    }, []);

    const loadForm = (data) => {
        dispatch(setSelectedCompositiontemplateId(data.ctid));
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleBatchSizeChange = (e) => {
        setShowError(false);
        const val = e.target.value;
        // Only update if value is a number (allow empty for clearing)
        if (/^\d*$/.test(val)) {
            updateTextValue(formValues, setFormValues, e);
        }
    }
    const allowOnlyNumberChange = (e) => {
        setShowError(false);
        const val = e.target.value;
        // Only update if value is a number (allow empty for clearing)
        if (/^\d*$/.test(val)) {
            updateTextValue(formValues, setFormValues, e);
        }
    }
    const allowOnlyDecimalChange = (e) => {
    setShowError(false);
    const val = e.target.value;

    // Allow empty string (for deletion) OR valid decimal pattern
    if (val === "" || /^\d+(\.\d{0,2})?$/.test(val)) {
        updateTextValue(formValues, setFormValues, e);
    }
};

    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues, e);
    }

    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        setApiInProgress(false);
        dispatch(addProductObj(obj.productInfo));
        dispatch(updatePharmaorderObj(obj.pharmaorderInfo));
        //setNotification('Record has been cretaed successfully !!!');
        dispatch(setInfoMsg("Product '" + obj.productInfo.title + "' is added successfully !!!"));
        dispatch(setShowEditForProduct(false));
    }
    const updateSuccessCallback = (obj) => {
        setApiInProgress(false);
        dispatch(updateProductObj(obj.productInfo));
        if (obj.pharmaorderInfo !== null)
            dispatch(updatePharmaorderObj(obj.pharmaorderInfo));
        //setNotification('Record with id[' + productId + '] has been updated successfully !!!');
        dispatch(setInfoMsg("Order for the Product '" + obj.productInfo.title + "' is updated successfully !!!"));
        dispatch(setShowEditForProduct(false));

    }
    const failuerCallback = (errorMsg) => {
        setApiInProgress(false);
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callAddProductAPI = () => {
        setApiInProgress(true);
        addProductAPI({
            "productInfo": formFieldToReqJSON(formValues)
        }, createSuccessCallback, failuerCallback)
    }
    const callUpdateProductAPI = () => {
        setApiInProgress(true);
        updateProductAPI({
            "updateProduct": formFieldToReqJSON(formValues)
        }, updateSuccessCallback, failuerCallback)
    }
    const [showTitleError, setShowTitleError] = useState(false);
    const [showPaymentError, setShowPaymentError] = useState(false);
    const [showGstError, setShowGstError] = useState(false);

// Update onSubmit to check for empty title, cr_cash, and gstid
const onSubmit = (e) => {
    e.preventDefault();
    if (!formValues.title.value || formValues.title.value.trim() === '') {
        setShowTitleError(true);
        return;
    }
    if (!formValues.cr_cash.value || formValues.cr_cash.value.trim() === '') {
        setShowPaymentError(true);
        return;
    }
    if (!formValues.gstid.value || formValues.gstid.value === 0 || formValues.gstid.value === "0") {
        setShowGstError(true);
        return;
    }
    handleSubmit(
        e,
        productId,
        formValues,
        setFormValues,
        createSuccessCallback,
        updateSuccessCallback,
        failuerCallback,
        callAddProductAPI,
        callUpdateProductAPI
    );
};

    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    useEffect(() => {
        if (editproductModalOpen === undefined || editproductModalOpen === false) {
            setApiInProgress(false);
        }
    }, [editproductModalOpen])

    const manageComposition = () => {
        // dispatch(setProductEditproductModal(true));
        setApiInProgress(true);
        dispatch(setProductEditproductModal(true));
    }
    const getSubTotalPrice = () =>{
        return Number(formValues.rate.value || 0) * Number(formValues.batchsize.value || 0) +
                Number(formValues.inventorycharges.value || 0) +
                Number(formValues.cylindercharges.value || 0)
    }
    const getSubtotalWithGST = () =>{
        return getSubTotalPrice()+getSubTotalPrice()*Number(formValues.gstname.value)/100;
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', height: { lg: '68vh', md: '60vh', sm: '55vh', xs: '55vh' } }}>
                        <Grid container direction="column" padding={1}>
                            {/* <Grid item>
                                <Typography variant='h4'>{productId === -1 ? 'Add Product' : 'Edit Product #' + productId}</Typography>
                                <Divider />
                            </Grid> */}
                            {/* <Grid height='20px' ></Grid> */}
                            <Grid container display="flex" direction="row" justifyContent="flex-left" alignItems="center" sx={{ width: '100%' }}>

                                <Grid item lg={12} xs={12} sx={{}}>
                                    <Grid container direction="row" alignItems="top" justifyContent="space-between" sx={{ width: '100%', }}>
                                        <Grid item lg={5} xs={12} sx={{ backgroundColor: 'secondary.100', padding: .5, borderRadius: 1, }}>
                                            <Grid container direction="row" alignItems="left" justifyContent="flex-start" sx={{ width: '100%', padding: 1, }}>
                                                <Grid item lg={12} xs={12} sx={{ width: '100%', paddingBottom: 1 }}>
                                                    <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                                        <Grid item xs={10}>
                                                            <Typography variant="h5" color="primary.dark">Selected Product:</Typography>
                                                        </Grid>

                                                        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            {apiInProgress ? <CircularProgress size={20} sx={{ color: 'primary.dark' }} /> :
                                                                <ModeEditIcon onClick={() => manageComposition()} sx={{ cursor: 'pointer', color: 'primary.dark' }} />
                                                            }
                                                        </Grid>


                                                    </Grid>
                                                </Grid>
                                                <Grid lg={12} xs={12} item sx={{ paddingTop: 1, height: '100%', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', pb: 1 }}>
                                                    <Typography
                                                        variant="h6"
                                                        color="primary.darker"
                                                        sx={{ borderRadius: 2, padding: 1, width: '100%', textAlign: 'center', wordBreak: 'break-word', borderBottom: '1px solid #e0e0e0' }}
                                                    >
                                                        {formValues.title.value ? formValues.title.value : 'Click edit icon to select'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item lg={6} xs={12} sx={{
                                                    pt: 0,
                                                    pr: 2,
                                                    backgroundColor: 'white',
                                                    paddingLeft: 1,
                                                    borderRadius: 1,
                                                   // display: compositiontemplateObj && compositiontemplateObj.id === undefined ? 'none' : '',
                                                    justifyContent: 'flex-end', // Align right
                                                    alignItems: 'flex-end',
                                                    //textAlign: 'right'
                                                }}>
                                                    <RadioForBoolean
                                                        label={formValues.repeatproduct.label}
                                                        fieldName={formValues.repeatproduct.name}
                                                        defaultValue={productObj.id!==undefined && productObj.repeatproduct?"yes":"no"}
                                                        handleChange={handleRadioChange}
                                                    />
                                                </Grid>
                                                <Grid item lg={6} xs={12} sx={{ pt: 1, backgroundColor: 'white', padding: 1, borderRadius: 1}}>
                                                    <FormControl sx={{ width: '100%' }} size="Large">
                                                        <InputLabel id="demo-simple-select-autowidth-label">GST</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-autowidth-label"
                                                            id="demo-simple-select-autowidth"
                                                            label="GST"
                                                            name={formValues.gstid.name}
                                                            value={formValues.gstid.value}
                                                            onChange={handleDynamicSelectedValueForgstid}

                                                            error={formValues.gstid.error}
                                                            helpertext={formValues.gstid.error && formValues.gstid.errorMessage}
                                                        >
                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                            {
                                                                gstList && gstList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                    <TextField size="Normal"
                                                        placeholder={formValues.gstname.placeholder}
                                                        required={formValues.gstname.required}
                                                        label={formValues.gstname.label}
                                                        name={formValues.gstname.name}
                                                        value={formValues.gstname.value}
                                                        onChange={handleTextChange}
                                                        error={formValues.gstname.error}
                                                        helperText={formValues.gstname.error && formValues.gstname.errorMessage}
                                                        sx={{ width: '100%' }}
                                                    />
                                                </Grid>
                                            </Grid>


                                            <Grid item lg={12} sx={{ backgroundColor: 'white', padding: 1, borderRadius: 1, display: 'none' }}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.title.placeholder}
                                                    required={formValues.title.required}
                                                    label={formValues.title.label}
                                                    name={formValues.title.name}
                                                    value={formValues.title.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.title.error}
                                                    helpertext={formValues.title.error && formValues.title.errorMessage}
                                                    disabled
                                                    sx={{ width: '100%', fontColor: 'primary.dark' }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item lg={4} xs={12} sx={{ paddingLeft: { lg: 1 }, border: '1px solid #fafafa', backgroundColor: 'white', borderRadius: 1, paddingTop: { xs: 2, lg: 0 } }}>
                                            <Grid item lg={12} sx={{ backgroundColor: 'secondary.100' }}>
                                                <Grid container sx={{ width: '100%', padding: 1, }}>
                                                    <Grid item lg={12} sx={{ paddingBottom: 1 }}>
                                                        <Typography variant="h5" color="primary.dark">Brand</Typography>
                                                    </Grid>
                                                    <Grid item lg={12} xs={12} sx={{ backgroundColor: 'white', padding: 2,  }}>
                                                        <TextField size="Normal"
                                                            placeholder={formValues.brandname.placeholder}
                                                            required={formValues.brandname.required}
                                                            label={formValues.brandname.label}
                                                            name={formValues.brandname.name}
                                                            value={formValues.brandname.value}
                                                            onChange={handleTextChange}
                                                            error={formValues.brandname.error}
                                                            helperText={formValues.brandname.error && formValues.brandname.errorMessage}
                                                            sx={{ width: '100%', }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} xs={6} sx={{ backgroundColor: 'white', padding: 1,}}>
                                                        <TextField size="Normal"
                                                            placeholder={formValues.rate.placeholder}
                                                            required={formValues.rate.required}
                                                            label={formValues.rate.label}
                                                            name={formValues.rate.name}
                                                            value={formValues.rate.value}
                                                            onChange={allowOnlyDecimalChange}
                                                            error={formValues.rate.error}
                                                            helpertext={formValues.rate.error && formValues.rate.errorMessage}
                                                            sx={{ width: '100%' }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} xs={6} sx={{ paddingTop: 0, backgroundColor: 'white', padding: 1, display: 'none'}}>
                                                        <TextField size="Normal"
                                                            placeholder={formValues.mrp.placeholder}
                                                            required={formValues.mrp.required}
                                                            label={formValues.mrp.label}
                                                            name={formValues.mrp.name}
                                                            value={formValues.mrp.value}
                                                            onChange={allowOnlyDecimalChange}
                                                            error={formValues.mrp.error}
                                                            helpertext={formValues.mrp.error && formValues.mrp.errorMessage}
                                                            sx={{ width: '100%' }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} xs={6} sx={{ paddingTop: 0, backgroundColor: 'white', padding: 1,  }}>
                                                        <TextField size="Normal"
                                                            placeholder={formValues.mrptext.placeholder}
                                                            required={formValues.mrptext.required}
                                                            label={formValues.mrptext.label}
                                                            name={formValues.mrptext.name}
                                                            value={formValues.mrptext.value}
                                                            onChange={handleTextChange}
                                                            error={formValues.mrptext.error}
                                                            helperText={formValues.mrptext.error && formValues.mrptext.errorMessage}
                                                            sx={{width:'100%'}}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                        <Grid item lg={3} xs={12} sx={{ backgroundColor: 'white', borderRadius: 1, paddingLeft: { lg: 1 }, paddingTop: { xs: 2, lg: 0 } }}>
                                            <Grid item lg={12} sx={{ backgroundColor: 'secondary.100', padding: 1, }}>
                                                <Typography variant="h5" color="primary.dark" sx={{ paddingBottom: 1 }}>Payment</Typography>
                                                <FormControl component="fieldset" fullWidth size="small" sx={{ padding: { lg: 1, xs: 1 }, backgroundColor: 'white', borderRadius: 1 }}>
                                                    <InputLabel shrink >

                                                    </InputLabel>
                                                    <RadioGroup
                                                        row
                                                        name={formValues.cr_cash.name}
                                                        value={formValues.cr_cash.value}
                                                        onChange={handleTextChange}
                                                    >
                                                        <FormControlLabel value="CASH" control={<Radio />} label="Cash" />
                                                        <FormControlLabel value="CREDIT" control={<Radio />} label="Credit" />
                                                    </RadioGroup>
                                                </FormControl>
                                                {/* <Grid item lg={12} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                                    <TextField size="Normal"
                                                        placeholder={formValues.advance.placeholder}
                                                        required={formValues.advance.required}
                                                        label="Advance Amount"
                                                        name={formValues.advance.name}
                                                        value={formValues.advance.value}
                                                        onChange={handleTextChange}
                                                        error={formValues.advance.error}
                                                        helperText={formValues.advance.error && formValues.advance.errorMessage}
                                                        sx={{width:'100%'}}
                                                    />
                                                </Grid> */}
                                                <Grid item lg={12} xs={12} sx={{ width: '100%', p:1, mt:1, backgroundColor: 'white', borderRadius: 1 }}>
                                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.executivename.label}</InputLabel>
                                                    <Typography variant="h6" color="primary.darker" sx={{ mt:1 }}>{formValues.executivename.value}</Typography>
                                                </Grid>
                                                {/* <Grid item lg={12} xs={12} sx={{ width: '100%', p:1, mt:1, backgroundColor: 'white', borderRadius: 1 }}>
                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.executivename.label}</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-autowidth-label"
                                                            id="demo-simple-select-autowidth"
                                                            label={formValues.executivename.label}
                                                            name={formValues.executivename.name}
                                                            value={formValues.executivename.value}
                                                            onChange={handleTextChange}
                                                            sx={{ width: '100%' }}

                                                            error={formValues.executivename.error}
                                                            helpertext={formValues.executivename.error && formValues.executivename.errorMessage}
                                                        >
                                                            {myBusinessUserList
                                                            .filter(item => item.rolename === 'PHARMA_OMS_SALES')
                                                            .map((item, i) => (
                                                                <MenuItem key={i} value={item.username}>{item.username}</MenuItem>
                                                            ))}
                                                    
                                                        </Select>
                                                    </FormControl>
                                                </Grid> */}
                                            </Grid>
                                            
                                        </Grid>
                                        <Grid item lg={3} xs={12} sx={{ backgroundColor: 'white', borderRadius: 1, paddingLeft: { lg: 0 }, paddingTop: { xs: 2, lg: 1 } }}>
                                            <Grid item lg={12} sx={{ backgroundColor: 'secondary.100', padding: 1, }}>
                                                <Typography variant="h5" color="primary.dark" sx={{ paddingBottom: 1 }}>Format</Typography>
                                                <Grid item xs={12} sx={{ width: '100%', backgroundColor: 'white', padding: 1 }}>
                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.formid.label}</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-autowidth-label"
                                                            id="demo-simple-select-autowidth"
                                                            label={formValues.formid.label}
                                                            name={formValues.formid.name}
                                                            value={formValues.formid.value}
                                                            onChange={handleDynamicSelectedValueForformid}
                                                            required={formValues.formid.required}
                                                            error={formValues.formid.error}
                                                            helpertext={formValues.formid.error && formValues.formid.errorMessage}
                                                            sx={{ width: '100%' }}
                                                        >
                                                            {
                                                                phproductformList && phproductformList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item lg={12} xs={12} sx={{  }}>
                                                    <Grid sx={{ width: '100%', padding: 1, backgroundColor: 'white' }}>
                                                        <TextField size="Normal"
                                                            placeholder={formValues.batchsize.placeholder}
                                                            required={formValues.batchsize.required}
                                                            label={formValues.batchsize.label}
                                                            name={formValues.batchsize.name}
                                                            value={formValues.batchsize.value}
                                                            onChange={handleBatchSizeChange}
                                                            error={formValues.batchsize.error}
                                                            helpertext={formValues.batchsize.error && formValues.batchsize.errorMessage}
                                                            sx={{ width: '100%', backgroundColor: 'white' }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item lg={!formValues.repeatproduct.value?5:9} xs={12} sx={{ border: '1px solid #fafafa', backgroundColor: 'white', borderRadius: 1, paddingLeft: { lg: 1 }, paddingTop: 1, paddingBottom: 2 }}>
                                            <Grid item lg={12} sx={{ backgroundColor: 'secondary.100', padding: 1, }}>
                                                <Typography variant="h5" color="primary.dark" sx={{}}>Packaging</Typography>
                                                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>


                                                    <Grid item lg={12} xs={12} sx={{ width: '100%', padding: 1, backgroundColor: 'white', mt: 1 }}>
                                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                                            <InputLabel id="demo-simple-select-autowidth-label">Packaging Material</InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-autowidth-label"
                                                                id="demo-simple-select-autowidth"
                                                                label="Packaging Material"
                                                                name={formValues.packagingtypeid.name}
                                                                value={formValues.packagingtypeid.value}
                                                                onChange={handleDynamicSelectedValueForpackagingtypeid}

                                                                error={formValues.packagingtypeid.error}
                                                                helpertext={formValues.packagingtypeid.error && formValues.packagingtypeid.errorMessage}
                                                                sx={{ width: '100%' }}
                                                            >
                                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                {
                                                                    phpackagingmaterialDashboard.phpackagingmaterialList && phpackagingmaterialDashboard.phpackagingmaterialList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    {
                                                        formValues.formname.value !== 'Tablet' && formValues.formname.value !== 'Capsul' && formValues.formname.value !== 'Capsule' && formValues.formname.value !== 'Sachet' ?
                                                            <>

                                                                <Grid item lg={12} xs={12} sx={{ width: '100%', padding: 1, backgroundColor: 'white' }}>
                                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                                        <InputLabel id="demo-simple-select-autowidth-label">
                                                                            {formValues.formname.value === 'Tube' || formValues.formname.value === 'Ointment' ? 'GRM(s) per Tube' : ''}
                                                                            {formValues.formname.value === 'Gargle' || formValues.formname.value === 'Lotion' || formValues.formname.value === 'Liquid' 
                                                                            || formValues.formname.value === 'Syrup'
                                                                            || formValues.formname.value === 'Ointment In Cream'
                                                                            || formValues.formname.value === 'Ointment In Gel' 
                                                                            || formValues.formname.value === 'Drop' 
                                                                            
                                                                            ? 'ML(s) per Packing' : ''}
                                                                        </InputLabel>
                                                                        <Select
                                                                            labelId="demo-simple-select-autowidth-label"
                                                                            id="demo-simple-select-autowidth"
                                                                            label={formValues.packagingsize2id.label}
                                                                            name={formValues.packagingsize2id.name}
                                                                            value={formValues.packagingsize2id.value}
                                                                            onChange={handleDynamicSelectedValueForpackagingsize2id}

                                                                            error={formValues.packagingsize2id.error}
                                                                            helpertext={formValues.packagingsize2id.error && formValues.packagingsize2id.errorMessage}
                                                                            sx={{ width: '100%' }}
                                                                        >
                                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                            {
                                                                                packagingsizeDashboard.packagingsizeList && packagingsizeDashboard.packagingsizeList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                                    <TextField size="Normal"
                                                                        placeholder={formValues.packagingsize2name.placeholder}
                                                                        required={formValues.packagingsize2name.required}
                                                                        label={formValues.packagingsize2name.label}
                                                                        name={formValues.packagingsize2name.name}
                                                                        value={formValues.packagingsize2name.value}
                                                                        onChange={handleTextChange}
                                                                        error={formValues.packagingsize2name.error}
                                                                        helpertext={formValues.packagingsize2name.error && formValues.packagingsize2name.errorMessage}
                                                                        sx={{ width: '100%' }}
                                                                    />
                                                                </Grid>


                                                            </> :
                                                            <>

                                                                {/* <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white' }} >
                                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                                        <InputLabel id="demo-simple-select-autowidth-label">
                                                                            {formValues.formname.value === 'Tablet' || formValues.formname.value === 'Capsul' ? 'Strip' : 'Sachet'}(s) Per Box</InputLabel>
                                                                        <Select
                                                                            labelId="demo-simple-select-autowidth-label"
                                                                            id="demo-simple-select-autowidth"
                                                                            label={formValues.packagingsize1id.label}
                                                                            name={formValues.packagingsize1id.name}
                                                                            value={formValues.packagingsize1id.value}
                                                                            onChange={handleDynamicSelectedValueForpackagingsize1id}

                                                                            error={formValues.packagingsize1id.error}
                                                                            helpertext={formValues.packagingsize1id.error && formValues.packagingsize1id.errorMessage}
                                                                        >
                                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                            {
                                                                                packagingsizeDashboard.packagingsizeList && packagingsizeDashboard.packagingsizeList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid> */}
                                                                {/* <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                                                    <TextField size="Normal"
                                                                        placeholder={formValues.packagingsize1name.placeholder}
                                                                        required={formValues.packagingsize1name.required}
                                                                        label={formValues.packagingsize1name.label}
                                                                        name={formValues.packagingsize1name.name}
                                                                        value={formValues.packagingsize1name.value}
                                                                        onChange={handleTextChange}
                                                                        error={formValues.packagingsize1name.error}
                                                                        helpertext={formValues.packagingsize1name.error && formValues.packagingsize1name.errorMessage}
                                                                        sx={{ width: '100%' }}
                                                                    />
                                                                </Grid> */}
                                                                {/* <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white' }} >
                                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                                        <InputLabel id="demo-simple-select-autowidth-label">
                                                                            {formValues.formname.value === 'Tablet' || formValues.formname.value === 'Capsul' ? 'Items per Strip' : 'GRM(s) per Sachet'}
                                                                        </InputLabel>
                                                                        <Select
                                                                            labelId="demo-simple-select-autowidth-label"
                                                                            id="demo-simple-select-autowidth"
                                                                            label={formValues.packagingsize2id.label}
                                                                            name={formValues.packagingsize2id.name}
                                                                            value={formValues.packagingsize2id.value}
                                                                            onChange={handleDynamicSelectedValueForpackagingsize2id}

                                                                            error={formValues.packagingsize2id.error}
                                                                            helpertext={formValues.packagingsize2id.error && formValues.packagingsize2id.errorMessage}
                                                                        >
                                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                            {
                                                                                packagingsizeDashboard.packagingsizeList && packagingsizeDashboard.packagingsizeList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid> */}

                                                                <Grid item lg={12} xs={12}>
                                                                                                <TextField size="Normal"
                                                                                                    placeholder={formValues.packagingtext.placeholder}
                                                                                                    required={formValues.packagingtext.required}
                                                                                                    label={formValues.packagingtext.label}
                                                                                                    name={formValues.packagingtext.name}
                                                                                                    value={formValues.packagingtext.value}
                                                                                                    onChange={handleTextChange}
                                                                                                    error={formValues.packagingtext.error}
                                                                                                    helperText={formValues.packagingtext.error && formValues.packagingtext.errorMessage}
                                                                                                    sx={{width:'100%', backgroundColor:'white', p:1}}
                                                                                                />
                                                                                            </Grid>
                                                                <Grid item lg={3} xs={12} sx={{ display: 'none', padding: 1 }}>
                                                                    <TextField size="Normal"
                                                                        placeholder={formValues.packagingsize2name.placeholder}
                                                                        required={formValues.packagingsize2name.required}
                                                                        label={formValues.packagingsize2name.label}
                                                                        name={formValues.packagingsize2name.name}
                                                                        value={formValues.packagingsize2name.value}
                                                                        onChange={handleTextChange}
                                                                        error={formValues.packagingsize2name.error}
                                                                        helpertext={formValues.packagingsize2name.error && formValues.packagingsize2name.errorMessage}
                                                                        sx={{ width: '100%' }}
                                                                    />
                                                                </Grid>



                                                                <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                                                    <TextField size="Normal"
                                                                        placeholder={formValues.packaging.placeholder}
                                                                        required={formValues.packaging.required}
                                                                        label={formValues.packaging.label}
                                                                        name={formValues.packaging.name}
                                                                        value={formValues.packaging.value}
                                                                        onChange={handleTextChange}
                                                                        error={formValues.packaging.error}
                                                                        helpertext={formValues.packaging.error && formValues.packaging.errorMessage}
                                                                        sx={{ width: '100%' }}
                                                                    />
                                                                </Grid>

                                                                <Grid item lg={3} xs={12} sx={{ padding: 1, display: 'none' }}>
                                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                                        <InputLabel id="demo-simple-select-autowidth-label">Shape</InputLabel>
                                                                        <Select
                                                                            labelId="demo-simple-select-autowidth-label"
                                                                            id="demo-simple-select-autowidth"
                                                                            label="Shape"
                                                                            name={formValues.shapeid.name}
                                                                            value={formValues.shapeid.value}
                                                                            onChange={handleDynamicSelectedValueForshapeid}

                                                                            error={formValues.shapeid.error}
                                                                            helpertext={formValues.shapeid.error && formValues.shapeid.errorMessage}
                                                                        >
                                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                            {
                                                                                phproductshapeDashboard.phproductshapeList && phproductshapeDashboard.phproductshapeList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item lg={2} xs={12} sx={{ padding: 1, display: 'none' }}>
                                                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                                                        <InputLabel id="demo-simple-select-autowidth-label">Set</InputLabel>
                                                                        <Select
                                                                            labelId="demo-simple-select-autowidth-label"
                                                                            id="demo-simple-select-autowidth"
                                                                            label="Set"
                                                                            name={formValues.setid.name}
                                                                            value={formValues.setid.value}
                                                                            onChange={handleDynamicSelectedValueForsetid}

                                                                            error={formValues.setid.error}
                                                                            helpertext={formValues.setid.error && formValues.setid.errorMessage}
                                                                        >
                                                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                            {
                                                                                pharmasetDashboard.pharmasetList && pharmasetDashboard.pharmasetList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item lg={2} xs={12} sx={{ display: 'none' }}>
                                                                    <TextField size="Normal"
                                                                        placeholder={formValues.setname.placeholder}
                                                                        required={formValues.setname.required}
                                                                        label={formValues.setname.label}
                                                                        name={formValues.setname.name}
                                                                        value={formValues.setname.value}
                                                                        onChange={handleTextChange}
                                                                        error={formValues.setname.error}
                                                                        helpertext={formValues.setname.error && formValues.setname.errorMessage}
                                                                        sx={{ width: '100%' }}
                                                                    />
                                                                </Grid>
                                                            </>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                        <Grid item lg={4} xs={12} sx={{  backgroundColor: 'white', borderRadius: 1, paddingLeft: { lg: 1 }, paddingTop: { xs: 2, lg: 1 } ,
                                                display:!formValues.repeatproduct.value?'':'none',
                                            }}>
                                            <Grid item lg={12} sx={{ backgroundColor: 'secondary.100', padding: 1, }}>
                                                <Typography variant="h5" color="primary.dark" sx={{ paddingBottom: 1 }}>Repeat Product Charges</Typography>
                                                <Grid item lg={12} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                                    <TextField size="Normal"
                                                        placeholder={formValues.inventorycharges.placeholder}
                                                        required={formValues.inventorycharges.required}
                                                        label={formValues.inventorycharges.label}
                                                        name={formValues.inventorycharges.name}
                                                        value={formValues.inventorycharges.value}
                                                        onChange={allowOnlyNumberChange}
                                                        error={formValues.inventorycharges.error}
                                                        helperText={formValues.inventorycharges.error && formValues.inventorycharges.errorMessage}
                                                        sx={{ width: '100%' }}
                                                    />
                                                </Grid>

                                                <Grid item lg={12} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                                    <TextField size="Normal"
                                                        placeholder={formValues.cylindercharges.placeholder}
                                                        required={formValues.cylindercharges.required}
                                                        label={formValues.cylindercharges.label}
                                                        name={formValues.cylindercharges.name}
                                                        value={formValues.cylindercharges.value}
                                                        onChange={allowOnlyNumberChange}
                                                        error={formValues.cylindercharges.error}
                                                        helperText={formValues.cylindercharges.error && formValues.cylindercharges.errorMessage}
                                                        sx={{ width: '100%' }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {formValues.formname.value==='Tablet' || formValues.formname.value==='Capsul'?
                                                <NonTabletPriceCalculation
                                                    form="Box"
                                                    repeatproduct={formValues.repeatproduct.value}
                                                    unitRate={Number(formValues.rate.value) || 0}
                                                    boxCount={Number(formValues.batchsize.value) || 0}
                                                    inventoryCharges={Number(formValues.inventorycharges.value) || 0}
                                                    cylinderCharges={Number(formValues.cylindercharges.value) || 0}
                                                    gstPercentage={Number(formValues.gstname.value) || 0}
                                                    />
                                        :  <NonTabletPriceCalculation
                                                    form={formValues.formname.value}
                                                    repeatproduct={formValues.repeatproduct.value}
                                                    unitRate={Number(formValues.rate.value) || 0}
                                                    boxCount={Number(formValues.batchsize.value) || 0}
                                                    inventoryCharges={Number(formValues.inventorycharges.value) || 0}
                                                    cylinderCharges={Number(formValues.cylindercharges.value) || 0}
                                                    gstPercentage={Number(formValues.gstname.value) || 0}
                                        
                                        />
                                        }
                                    </Grid>
                                </Grid>


                                {/* <Grid item lg={2} xs={2} sx={{display:'none'}}>
                                       
                                    </Grid> */}

                                <Grid item lg={2} xs={12} sx={{ width: '100%', display: 'none' }}>
                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.cr_cash.label}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.cr_cash.label}
                                            name={formValues.cr_cash.name}
                                            value={formValues.cr_cash.value}
                                            onChange={handleTextChange}

                                            error={formValues.cr_cash.error}
                                            helpertext={formValues.cr_cash.error && formValues.cr_cash.errorMessage}
                                        >

                                            <MenuItem value="CREDIT">CREDIT</MenuItem>
                                            <MenuItem value="CASH">CASH</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item lg={2} xs={12} sx={{ width: '100%', display: 'none' }}>
                                    <MyDate
                                        label={formValues.expirydate.label}
                                        fieldName={formValues.expirydate.name}
                                        defaultValue={Date()}
                                        errStr={formValues.expirydate.errorMessage}
                                        setDate={setDate}
                                    />
                                </Grid>





                                <Grid item lg={12} xs={12} >
                                    <TextField size="Normal"
                                        placeholder={formValues.remarks.placeholder}
                                        required={formValues.remarks.required}
                                        label={formValues.remarks.label}
                                        multiline
                                        rows={1}
                                        name={formValues.remarks.name}
                                        value={formValues.remarks.value}
                                        onChange={handleTextChange}
                                        error={formValues.remarks.error}
                                        helpertext={formValues.remarks.error && formValues.remarks.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.partyid.placeholder}
                                        required={formValues.partyid.required}
                                        label={formValues.partyid.label}
                                        name={formValues.partyid.name}
                                        value={formValues.partyid.value}
                                        onChange={handleTextChange}
                                        error={formValues.partyid.error}
                                        helpertext={formValues.partyid.error && formValues.partyid.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.businessid.placeholder}
                                        required={formValues.businessid.required}
                                        label={formValues.businessid.label}
                                        name={formValues.businessid.name}
                                        value={formValues.businessid.value}
                                        onChange={handleTextChange}
                                        error={formValues.businessid.error}
                                        helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.designvendorname.placeholder}
                                        required={formValues.designvendorname.required}
                                        label={formValues.designvendorname.label}
                                        name={formValues.designvendorname.name}
                                        value={formValues.designvendorname.value}
                                        onChange={handleTextChange}
                                        error={formValues.designvendorname.error}
                                        helpertext={formValues.designvendorname.error && formValues.designvendorname.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>
                                <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                    <MyDate
                                        label={formValues.designdispatched.label}
                                        fieldName={formValues.designdispatched.name}
                                        defaultValue={formValues.designdispatched.value}
                                        errStr={formValues.designdispatched.errorMessage}
                                        setDate={setDate}
                                    />
                                </Grid>


                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.shapename.placeholder}
                                        required={formValues.shapename.required}
                                        label={formValues.shapename.label}
                                        name={formValues.shapename.name}
                                        value={formValues.shapename.value}
                                        onChange={handleTextChange}
                                        error={formValues.shapename.error}
                                        helpertext={formValues.shapename.error && formValues.shapename.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.formname.placeholder}
                                        required={formValues.formname.required}
                                        label={formValues.formname.label}
                                        name={formValues.formname.name}
                                        value={formValues.formname.value}
                                        onChange={handleTextChange}
                                        error={formValues.formname.error}
                                        helpertext={formValues.formname.error && formValues.formname.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.statusname.placeholder}
                                        required={formValues.statusname.required}
                                        label={formValues.statusname.label}
                                        name={formValues.statusname.name}
                                        value={formValues.statusname.value}
                                        onChange={handleTextChange}
                                        error={formValues.statusname.error}
                                        helpertext={formValues.statusname.error && formValues.statusname.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.packagingtypename.placeholder}
                                        required={formValues.packagingtypename.required}
                                        label={formValues.packagingtypename.label}
                                        name={formValues.packagingtypename.name}
                                        value={formValues.packagingtypename.value}
                                        onChange={handleTextChange}
                                        error={formValues.packagingtypename.error}
                                        helpertext={formValues.packagingtypename.error && formValues.packagingtypename.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>


                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.partyname.placeholder}
                                        required={formValues.partyname.required}
                                        label={formValues.partyname.label}
                                        name={formValues.partyname.name}
                                        value={formValues.partyname.value}
                                        onChange={handleTextChange}
                                        error={formValues.partyname.error}
                                        helpertext={formValues.partyname.error && formValues.partyname.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.orderid.placeholder}
                                        required={formValues.orderid.required}
                                        label={formValues.orderid.label}
                                        name={formValues.orderid.name}
                                        value={formValues.orderid.value}
                                        onChange={handleTextChange}
                                        error={formValues.orderid.error}
                                        helpertext={formValues.orderid.error && formValues.orderid.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>



                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.amount.placeholder}
                                        required={formValues.amount.required}
                                        label={formValues.amount.label}
                                        name={formValues.amount.name}
                                        value={formValues.amount.value}
                                        onChange={handleTextChange}
                                        error={formValues.amount.error}
                                        helpertext={formValues.amount.error && formValues.amount.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ width: '100%', display: 'none' }}>
                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.executivename.label}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.executivename.label}
                                            name={formValues.executivename.name}
                                            value={formValues.executivename.value}
                                            onChange={handleTextChange}

                                            error={formValues.executivename.error}
                                            helpertext={formValues.executivename.error && formValues.executivename.errorMessage}
                                        >

                                            <MenuItem value="EXEC 1">EXEC 1</MenuItem>
                                            <MenuItem value="EXEC 2">EXEC 2</MenuItem>
                                            <MenuItem value="EXEC 3">EXEC 3</MenuItem>
                                            <MenuItem value="EXEC 4">EXEC 4</MenuItem>
                                            <MenuItem value="EXEC 5">EXEC 5</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                    <MyDate
                                        label={formValues.dispatchdate.label}
                                        fieldName={formValues.dispatchdate.name}
                                        defaultValue={formValues.dispatchdate.value}
                                        errStr={formValues.dispatchdate.errorMessage}
                                        setDate={setDate}
                                    />
                                </Grid>


                                <Grid item lg={4} xs={12} sx={{ width: '100%', display: 'none' }}>
                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.batchpackaging.label}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.batchpackaging.label}
                                            name={formValues.batchpackaging.name}
                                            value={formValues.batchpackaging.value}
                                            onChange={handleTextChange}

                                            error={formValues.batchpackaging.error}
                                            helpertext={formValues.batchpackaging.error && formValues.batchpackaging.errorMessage}
                                        >

                                            <MenuItem value="ALU ALU">ALU ALU</MenuItem>
                                            <MenuItem value="BLISTER">BLISTER</MenuItem>
                                            <MenuItem value="DROP">DROP</MenuItem>
                                            <MenuItem value="BOTTLE">BOTTLE</MenuItem>
                                            <MenuItem value="JAR">JAR</MenuItem>
                                            <MenuItem value="LONG STRIP">LONG STRIP</MenuItem>
                                            <MenuItem value="METALIC CRTN">METALIC CRTN</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid item lg={4} xs={12} sx={{ width: '100%', display: 'none' }}>
                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.designstatus.label}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.designstatus.label}
                                            name={formValues.designstatus.name}
                                            value={formValues.designstatus.value}
                                            onChange={handleTextChange}

                                            error={formValues.designstatus.error}
                                            helpertext={formValues.designstatus.error && formValues.designstatus.errorMessage}
                                        >

                                            <MenuItem value="DESIGNING">DESIGNING</MenuItem>
                                            <MenuItem value="APPROVAL_PENDING">APPROVAL_PENDING</MenuItem>
                                            <MenuItem value="APPROVED">APPROVED</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ width: '100%', display: 'none' }}>
                                    <FormControl sx={{ width: '100%' }} size="Normal">
                                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.statusid.label}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.statusid.label}
                                            name={formValues.statusid.name}
                                            value={formValues.statusid.value}
                                            onChange={handleDynamicSelectedValueForstatusid}

                                            error={formValues.statusid.error}
                                            helpertext={formValues.statusid.error && formValues.statusid.errorMessage}
                                        >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                phproductstatusList && phproductstatusList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.foillabel.placeholder}
                                        required={formValues.foillabel.required}
                                        label={formValues.foillabel.label}
                                        name={formValues.foillabel.name}
                                        value={formValues.foillabel.value}
                                        onChange={handleTextChange}
                                        error={formValues.foillabel.error}
                                        helpertext={formValues.foillabel.error && formValues.foillabel.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>




                                <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                    <MyDate
                                        label={formValues.podate.label}
                                        fieldName={formValues.podate.name}
                                        defaultValue={formValues.podate.value}
                                        errStr={formValues.podate.errorMessage}
                                        setDate={setDate}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.packagingremarks.placeholder}
                                        required={formValues.packagingremarks.required}
                                        label={formValues.packagingremarks.label}
                                        name={formValues.packagingremarks.name}
                                        value={formValues.packagingremarks.value}
                                        onChange={handleTextChange}
                                        error={formValues.packagingremarks.error}
                                        helpertext={formValues.packagingremarks.error && formValues.packagingremarks.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>

                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.dispatchedsize.placeholder}
                                        required={formValues.dispatchedsize.required}
                                        label={formValues.dispatchedsize.label}
                                        name={formValues.dispatchedsize.name}
                                        value={formValues.dispatchedsize.value}
                                        onChange={handleTextChange}
                                        error={formValues.dispatchedsize.error}
                                        helpertext={formValues.dispatchedsize.error && formValues.dispatchedsize.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>




                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.businessid.placeholder}
                                        required={formValues.businessid.required}
                                        label={formValues.businessid.label}
                                        name={formValues.businessid.name}
                                        value={formValues.businessid.value}
                                        onChange={handleTextChange}
                                        error={formValues.businessid.error}
                                        helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                        sx={{ width: '100%' }}
                                    />
                                </Grid>
                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                    <TextField size="Normal"
                                        placeholder={formValues.ctid.placeholder}
                                        required={formValues.ctid.required}
                                        label={formValues.ctid.label}
                                        name={formValues.ctid.name}
                                        value={formValues.ctid.value}
                                        onChange={handleTextChange}
                                        error={formValues.ctid.error}
                                        helpertext={formValues.ctid.error && formValues.ctid.errorMessage}
                                        sx={{ width: '100%', }}
                                    />
                                </Grid>
                                <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                                <TextField size="Normal"
                                                                    placeholder={formValues.overallstatusid.placeholder}
                                                                    required={formValues.overallstatusid.required}
                                                                    label={formValues.overallstatusid.label}
                                                                    name={formValues.overallstatusid.name}
                                                                    value={formValues.overallstatusid.value}
                                                                    onChange={handleTextChange}
                                                                    error={formValues.overallstatusid.error}
                                                                    helperText={formValues.overallstatusid.error && formValues.overallstatusid.errorMessage}
                                                                    sx={{width:'100%'}}
                                                                />
                                                            </Grid>

                                                            <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                                                            <TextField size="Normal"
                                                                                                placeholder={formValues.monthtagid.placeholder}
                                                                                                required={formValues.monthtagid.required}
                                                                                                label={formValues.monthtagid.label}
                                                                                                name={formValues.monthtagid.name}
                                                                                                value={formValues.monthtagid.value}
                                                                                                onChange={handleTextChange}
                                                                                                error={formValues.monthtagid.error}
                                                                                                helperText={formValues.monthtagid.error && formValues.monthtagid.errorMessage}
                                                                                                sx={{width:'100%'}}
                                                                                            />
                                                                                        </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Box>
                {/* <Grid height='25px' ></Grid> */}
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{productId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForProduct(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
            <EditproductActionModal />

            <Dialog open={showTitleError} onClose={() => setShowTitleError(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ bgcolor: 'error.main', color: 'white' }}>
                    Error
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h6" sx={{ paddingTop: 2 }}>
                        Product title cannot be empty.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="error" onClick={() => setShowTitleError(false)}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={showPaymentError} onClose={() => setShowPaymentError(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ bgcolor: 'error.main', color: 'white' }}>
                    Error
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h6" sx={{ paddingTop: 2 }}>
                        Payment type must be selected.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="error" onClick={() => setShowPaymentError(false)}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={showGstError} onClose={() => setShowGstError(false)} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ bgcolor: 'error.main', color: 'white' }}>
        Error
    </DialogTitle>
    <DialogContent>
        <Typography variant="h6" sx={{ paddingTop: 2 }}>
            GST must be selected.
        </Typography>
    </DialogContent>
    <DialogActions>
        <Button variant="contained" color="error" onClick={() => setShowGstError(false)}>
            OK
        </Button>
    </DialogActions>
</Dialog>
        </form>

    );
};